// extracted by mini-css-extract-plugin
export default {"footerForm":"style_footerForm__tpVoj","footerForm-min":"style_footerForm-min__V9JB-","buttons":"style_buttons__JB16R","buttons-min":"style_buttons-min__fbdbt"};